import emailjs from '@emailjs/browser';

// 1. Logge dich bei emailjs.com ein
// 2. Erstelle einen "Email Service" (z.B. Gmail) -> Kopiere die Service ID
// 3. Erstelle ein "Email Template" -> Kopiere die Template ID
// 4. Gehe zu "Account" -> API Keys -> Kopiere den Public Key

const SERVICE_ID = "service_ulwajwe";
const TEMPLATE_ID = "template_k1t9757";
const PUBLIC_KEY = "ttX_Xpw0irT7vGe2o";

export const sendLeadEmail = async (userInfo) => {
  try {
    const templateParams = {
      user_name: userInfo.name,
      user_email: userInfo.email,
      to_email: 'post@evaendruweit.de',
      subject: 'Neuer Lead: Stress-Typ-Check'
    };

    const response = await emailjs.send(
      SERVICE_ID,
      TEMPLATE_ID,
      templateParams,
      PUBLIC_KEY
    );
    
    return response;
  } catch (error) {
    console.error('EmailJS Error:', error);
    throw error;
  }
};